import React from 'react';
import {connect} from "react-redux";
import { withStyles } from 'material-ui/styles';

const ErrorMessage=({error, classes})=>{
    if(error===undefined)return null;
    return <div className='in-the-center error-container'>
        {error}
    </div>
};

const mapStateToProps=(state)=>({error:state.process.error});
const ConnectedError=connect(mapStateToProps)(ErrorMessage);
export default ConnectedError;